import React, { useState } from 'react';
import { Sun, Moon, Monitor, Check } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import useClickOutside from '../hooks/useClickOutside';

const OPTIONS = [
  { id: 'light', label: 'Light', Icon: Sun },
  { id: 'dark', label: 'Night', Icon: Moon },
  { id: 'system', label: 'System', Icon: Monitor },
];

// Header control for night mode: icon reflects the active theme, the menu
// picks light / night / follow the OS.
export default function ThemeToggle() {
  const { preference, theme, setPreference } = useTheme();
  const [open, setOpen] = useState(false);
  const ref = useClickOutside(open, () => setOpen(false));

  const ActiveIcon = theme === 'dark' ? Moon : Sun;

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-md"
        title="Appearance"
        aria-label="Appearance"
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <ActiveIcon size={20} />
      </button>
      {open && (
        <div
          role="menu"
          className="absolute right-0 top-12 z-50 w-44 bg-white rounded-lg shadow-lg border border-gray-200 py-1"
        >
          <p className="px-3 pt-1.5 pb-1 text-[11px] font-semibold uppercase tracking-wide text-gray-400">
            Appearance
          </p>
          {OPTIONS.map(({ id, label, Icon }) => {
            const selected = preference === id;
            return (
              <button
                key={id}
                type="button"
                role="menuitemradio"
                aria-checked={selected}
                onClick={() => { setPreference(id); setOpen(false); }}
                className={`w-full flex items-center gap-2.5 px-3 py-2 text-sm text-left hover:bg-gray-50 ${selected ? 'text-primary-700 font-medium' : 'text-gray-700'}`}
              >
                <Icon size={16} className={selected ? 'text-primary-600' : 'text-gray-400'} />
                <span className="flex-1">{label}</span>
                {selected && <Check size={14} className="text-primary-600" />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
